import React from 'react'

const IconInfo = (props) => {
  const width = props.width || props.size
  const height = props.height || props.size

  return (
    <svg
      data-testid="info-icon"
      width={width}
      height={height}
      viewBox="0 0 14.4 14.4"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.60001 10.2H7.80001V6.60001H6.60001V10.2ZM7.20001 1.20001C3.88801 1.20001 1.20001 3.88801 1.20001 7.20001C1.20001 10.512 3.88801 13.2 7.20001 13.2C10.512 13.2 13.2 10.512 13.2 7.20001C13.2 3.88801 10.512 1.20001 7.20001 1.20001ZM7.20001 12C4.55401 12 2.40001 9.84601 2.40001 7.20001C2.40001 4.55401 4.55401 2.40001 7.20001 2.40001C9.84601 2.40001 12 4.55401 12 7.20001C12 9.84601 9.84601 12 7.20001 12ZM6.60001 5.40001H7.80001V4.20001H6.60001V5.40001Z"
        fill={props.color}
      />
    </svg>
  )
}

IconInfo.defaultProps = {
  color: 'currentcolor',
  size: '1em',
}

export default IconInfo
